import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { ButtonBasic } from "@lk-gtcom/ecomlab-components";
import done from './img/done.svg'
import edit_icon from './img/edit_icon.svg'
import price_icon from './img/price_icon.svg'
import transfer_icon from './img/transfer_icon.svg'
import { ModalComponent } from '../ModalComponent/ModalComponent';
import './ModalCardCreated.scss'

const info_content = [
    { label: 'Переносить товары', icon: transfer_icon },
    { label: 'Менять цены', icon: price_icon },
    { label: 'Редактировать', icon: edit_icon }
]

const ModalCardCreated = ({ ...props }) => {
    const {
        setIsModal,
        fetchProductIds
    } = props

    const navigate = useNavigate();

    return (
        <ModalComponent
            title='Карточка создана успешно'
            onClose={e => setIsModal(false)}
            style={{
                maxWidth: '600px',
                height: 'auto'
            }}
            child={
                <div className='modal-card-created'>
                    <img src={done} />
                    <div className='modal-card-created__content'>
                        <p className='text'>Добавим ее в течение 2 минут в <Link className='link_blue' to='/products_list_master_product/all'>Список товаров</Link></p>
                    </div>

                    <div className='modal-card-created__info-content'>
                        <h3 className='title'>Вы можете работать с вашими товарами:</h3>
                        <div className='content-points'>
                            {info_content.map(({ label, icon }, ind) =>
                                <div className='point-item' key={label + ind}>
                                    <p className='text'>{label}</p>
                                    <img className='icon' src={icon} />
                                </div>
                            )}
                        </div>
                    </div>

                    <div className='btn-group'>
                        <ButtonBasic
                            lilac
                            text='К списку товаров'
                            width={`calc(50% - 6px)`}
                            onClick={(e) => {
                                navigate('/products_list_master_product/all')
                                setIsModal(false)
                            }}
                        />
                        <ButtonBasic
                            violet
                            text='Продолжить редактирование'
                            width={`calc(50% - 6px)`}
                            onClick={(e) => {
                                fetchProductIds(false)
                                setIsModal(false)
                            }}
                        />
                    </div>
                </div>
            }
        />
    )
}

export { ModalCardCreated }